import { useEffect } from "react";
import { usePortableVideoStore } from "store";
import { useLocation } from "react-router-dom";

export const usePortableVideo = () => {
  const videoRef = usePortableVideoStore((state) => state.videoRef);
  const targetRef = usePortableVideoStore((state) => state.targetRef);
  const videoAttributes = usePortableVideoStore((state) => state.videoAttributes);
  const updateVideo = usePortableVideoStore((state) => state.updateVideo);
  const location = useLocation();

  // prevent stop video when changing location and the same video is playing
  useEffect(() => {
    updateVideo({});
  }, [location]);

  useEffect(() => {
    if (!videoRef.current) {
      return;
    }

    videoRef.current.classList.remove(...videoRef.current.classList);
    targetRef.current?.appendChild(videoRef.current);
  }, [targetRef]);

  useEffect(() => {
    if (!videoRef.current) {
      return;
    }

    videoRef.current.load();
  }, [videoAttributes.src]);

  return {
    videoRef,
    videoAttributes
  };
};
